import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import traverseIcon from '../../../../assets/images/traverse-logo.png'

import * as navigationActions from '../../../../store/actions/index';

const mobileNavigation = (props) => {
    return (
        <nav className={`pt-3 pb-3 pl-5 pr-5 u-width100Percent u-flex align-items-center justify-content-between u-borderBottomNormal u-phoneShow u-backgroundColorWhite u-top0 u-left0 u-zIndex9 u-sticky`}>
            <div className={`u-size20x20 u-noUserSelect`} onClick={() => props.history.push('/')}>
                <img src={traverseIcon} alt='Traverse Icon' className={`u-width100Percent`}/> 
            </div>
            <div>
                <h4 className={`u-fontSize11 u-fontWeightMedium u-textColorPrimary u-textUppercase u-cursorPointer`} onClick={() => {
                    props.onSetAuthView('home');
                    props.onStartAuthentication();
                }}>Login/Register</h4>
            </div>
        </nav>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        onSetAuthView: (view) => dispatch(navigationActions.setAuthView(view)),
        onStartAuthentication: () => dispatch(navigationActions.startAuthentication()),
    }
}

export default withRouter(connect(null, mapDispatchToProps)(mobileNavigation));


// WEBPACK FOOTER //
// ./src/components/UI/Mobile/MobileNavigation/MobileNavigation.js